const APP_BUILD_PATTERN = /; (\d+)\) vio-flutter/

/**
 * Reads the build just before vio-flutter in the app WebView user agent, as in
 * "(…; en; 5736) vio-flutter".
 */
export const getFlutterAppBuild = (): number | undefined => {
  if (typeof window === 'undefined') return undefined

  const build = window.navigator?.userAgent?.match(APP_BUILD_PATTERN)?.[1]

  return build ? Number(build) : undefined
}
